export enum Languages {
  AR = 'ar',
  EN = 'en'
}
